(function ($) {

    if (!Modernizr.placeholder) {
        var ph = $('[placeholder]');

        if(ph.length) {
            $.getScript(wp_ajax.template_dir + '/js/lib/jquery.placeholder.min.js', function () {
                ph.placeholder();
            });
        }
    }

})
(jQuery);